import React, { useState } from "react";
import { specialCustomerBulkUpload } from "../../api/IrsClient";
import Modal from "../common/Modal";
import { ERROR_PREFIX_REGEX, SPECIAL_CUSTOMER_CSV_HEADERS } from "../../constant";

function BulkUploadModal({
  isOpen,
  onOk,
  onCancel,
  setInfoModal,
  setErrorModal
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState();

  function handleOnFileChange(e) {
    if (e.target.files) {
      setSelectedFile(e.target.files[0]);
    }
  }

  function handleOnClickDownload() {
    const csv = generateCSVTemplate();
    const link = document.createElement("a");
    link.setAttribute("href", URL.createObjectURL(csv));
    link.setAttribute("download", "special-customer-template.csv");
    link.addEventListener("click", () => {
      setTimeout(() => URL.revokeObjectURL(link.href), 30 * 1000);
    })
    link.click();
    link.remove();
  }

  function generateCSVTemplate() {
    return new Blob(
      [SPECIAL_CUSTOMER_CSV_HEADERS.join(",")],
      { type: "text/csv;charset=utf-8," }
    );
  }

  async function handleOnClickUpload() {
    try {
      setIsLoading(true);
      const { data: { status } } = await specialCustomerBulkUpload(selectedFile);
      if (status.code === "0") {
        setInfoModal({
          title: `Upload file successfully.`,
          description: "The system will notify you via your corporate email of the operation result after the process is completed.",
          textOk: "OK",
          onOk: () => setInfoModal(null)
        });
        onOk();
      } else {
        setErrorModal({
          title: "Bulk upload error",
          description: status.message.replace(ERROR_PREFIX_REGEX, "")
        });
      }
    } catch (error) {
      setErrorModal({
        description: error?.response?.data?.status.message.replace(ERROR_PREFIX_REGEX, "")
      });
    } finally {
      setIsLoading(false);
      setSelectedFile(null);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onOk={onOk}
      onCancel={onCancel}
      zIndex="5000"
    >
      <div className="exchange-rate-modal">
        <button
          type="button"
          className="close"
          aria-label="Close"
          data-testid="close-bulk-upload-modal"
          onClick={(onCancel)}
        >
          <span aria-hidden="true">×</span>
        </button>
        <div className="custom-modal-content">
          <h5 className="custom-modal-message text-center p-3">Bulk Upload Special Customer</h5>

          <div className="custom-modal-description text-center">
            {selectedFile && <strong>Seleted File: {selectedFile?.name}</strong>}
            <div className="browse-file">
              <input
                id="upload-file"
                data-testid="upload-file"
                className="upload-file"
                type="file"
                name="file"
                accept=".csv"
                onChange={handleOnFileChange}
              />
              <label className="btn btn-dashed" htmlFor="upload-file">
                Browse File
              </label>
            </div>
            <p>* Accept only CSV file and limited to 1,500 rows / file as a maximum.</p>
          </div>
        </div>

        <div className="custom-modal-action">
          <button
            className="btn btn-secondary"
            data-testid="download-template-button"
            type="button"
            onClick={handleOnClickDownload}
            disabled={isLoading}
          >
            Download CSV Template
          </button>
          <button
            className="btn btn-warning"
            data-testid="upload-button"
            type="button"
            onClick={handleOnClickUpload}
            disabled={isLoading || !selectedFile}
          >
            Upload
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default BulkUploadModal;